// extracted by mini-css-extract-plugin
export default {"modal":"VideoModal_modal__pl9Wc","header":"VideoModal_header__WG2vr","draggable":"VideoModal_draggable__CLf5J","body":"VideoModal_body__5+PDn","footer":"VideoModal_footer__yo+Qc"};